import React, { FC } from 'react';
import { Box } from '@mui/material';
import { SCUIGeneralModal } from '../../../atomic/molecules';
import { SCUIOperatorSearch } from '../SCUIOperatorSearch/SCUIOperatorSearch';
import DialogContent from '@mui/material/DialogContent';
import './SCUIOperatorDialog.scss';
import { useTranslation } from 'react-i18next';
interface IProps {
    roleId?: any;
    open?: boolean;
    onClose?: any;
    refreshOperatorList?: any;
}
export const SCUIOperatorDialog: FC<IProps> = ({ roleId, open = false, onClose, refreshOperatorList }) => {
    const { t } = useTranslation();

    return (
        <SCUIGeneralModal
            open={open}
            onClose={onClose}
            title={t('authorizationManagement.userEdit.selectOperator')}
            width={'sm'}
        >
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <SCUIOperatorSearch roleId={roleId} onRefresh={refreshOperatorList} onClose={onClose} />
                </Box>
            </DialogContent>
        </SCUIGeneralModal>
    );
};
